import React from 'react';
import PropTypes from 'prop-types';
import BasePaths from './BasePaths';

export const BASEPATH_WIDTH = 36;
export const BASEPATH_MOBILE_WIDTH = 27;

const BasePathComponent = ({
    first,
    second,
    third,
    width,
    activeColor = 'var(--gameday-basepath-color)'
}) => {
    return (
        <BasePaths
            first={ first }
            second={ second }
            third={ third }
            width={ width }
            activeColor={activeColor}
        />
    );
};

BasePathComponent.propTypes = {
    first: PropTypes.bool,
    second: PropTypes.bool,
    third: PropTypes.bool,
    width: PropTypes.number,
    activeColor: PropTypes.string
};

export default BasePathComponent;
